import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const dashboardModule: ForqModuleManifest = {
  id: 'dashboard',
  name: 'Dashboard',
  description: 'Persönliche und rollenabhängige Startseite',
  version: '0.1.0',
  route: '/dashboard',
  category: 'start',
  status: 'development',
  requiredPermissions: ['dashboard.view'],
  features: [
    'dashboard.kpis',
    'dashboard.tasks',
    'dashboard.quick-actions',
    'dashboard.architecture',
  ],
  navigation: [
    {
      id: 'dashboard.home', label: 'Dashboard', route: '/dashboard',
      placement: 'primary', order: 10, icon: 'dashboard',
    },
    {
      id: 'dashboard.launcher', label: 'Dashboard', route: '/dashboard',
      placement: 'launcher', order: 10, icon: 'dashboard',
    },
  ],
};

export const dashboardFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'dashboard.kpis', moduleId: 'dashboard', name: 'Kennzahlen',
    description: 'Mandantenabhängige Kennzahlen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['dashboard.kpis.view'], uiSlots: ['dashboard.main'], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'dashboard.tasks', moduleId: 'dashboard', name: 'Offene Aufgaben',
    description: 'Persönliche Aufgaben und Freigaben', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['dashboard.tasks.view'], uiSlots: ['dashboard.aside'], emits: ['task.opened'], listensTo: [],
  },
  {
    id: 'dashboard.quick-actions', moduleId: 'dashboard', name: 'Schnellaktionen',
    description: 'Häufige Aktionen ohne Umwege', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['dashboard.quick-actions.view'], uiSlots: ['dashboard.main'], emits: ['quick-action.started'], listensTo: [],
  },
  {
    id: 'dashboard.architecture', moduleId: 'dashboard', name: 'Architekturstatus',
    description: 'Nachweis der modularen Foundation', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['dashboard.architecture.view'], uiSlots: ['dashboard.aside'], emits: [], listensTo: [],
  },
];
